export default "__VITE_ASSET__Br6oHZdK__"